module.exports = __webpack_public_path__ + "static/mark-69becf7944b93553277f2c607396f6dc.svg";